import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['integrationCategoryId', 'integrationSubCategoryId']

  communityId = $(this.integrationCategoryIdTarget).data('communityId')
  hasSubSubCategories = $('#maintenance_request_integration_sub_sub_category_id').length > 0

  connect() {
    // converts select2 events into native events
    $('#maintenance_request_integration_category_id').on('select2:select', function () {
      let event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    });

    if (this.hasSubSubCategories) {
      $('#maintenance_request_integration_sub_category_id').on('select2:select', function () {
        let event = new Event('change', { bubbles: true });
        this.dispatchEvent(event);
      });
    }
  }

  getSubCategories() {
    let integrationCategoryId = this.integrationCategoryIdTarget.value
    let integrationSubCategories = document.getElementById('maintenance_request_integration_sub_category_id')

    if (integrationCategoryId) {
      $.get({
        url: `/admin/communities/${this.communityId}/maintenance_requests/get_sub_categories`,
        data: {
          integration_category_id: integrationCategoryId
        },
        success: (results) => {
          $(integrationSubCategories).replaceWith(results)
        }
      })
      // Wait for the sub-categories to be loaded before getting the sub-sub-categories
      // Also, this resets sub-sub-categories when integration categories are changed
      if (this.hasSubSubCategories) {
        setTimeout(() => {
          this.getSubSubCategories()
        }, 500)
      }
    }
  }

  getSubSubCategories() {
    let integrationSubCategoryId = this.integrationSubCategoryIdTarget.value
    let integrationSubSubCategories = document.getElementById('maintenance_request_integration_sub_sub_category_id')

    if (integrationSubCategoryId) {
      $.get({
        url: `/admin/communities/${this.communityId}/maintenance_requests/get_sub_sub_categories`,
        data: {
          integration_sub_category_id: integrationSubCategoryId
        },
        success: (results) => {
          $(integrationSubSubCategories).replaceWith(results)
        }
      })
    } else {
      $(integrationSubSubCategories).replaceWith(
        `<select id="maintenance_request_integration_sub_sub_category_id" name="maintenance_request[integration_sub_sub_category_id]">
          <option value=""></option>
        </select>`
      )
    }
  }
}
